<template>
  <el-form ref="otherPayFrom" :model="tableDataFrom" :rules="rules">
    <el-table
      class="add-table"
      :data="tableDataFrom.tableData"
      style="width: 100%"
      row-key="num"
      max-height="350"
    >
      <el-table-column align="center" label="期数" width="100" prop="num">
      </el-table-column>
      <el-table-column align="left" :label="`${receiveOrPayFlag?'付':'收'}款类型`" width="100">
        <template>
          <el-form-item>
            <span>{{ getFreeTypeName(fundType) }}</span>
          </el-form-item>
        </template>
      </el-table-column>
      <el-table-column align="left" width="200" :label="`应${receiveOrPayFlag?'付':'收'}金额`">
        <template slot-scope="scope">
          <el-form-item
            :prop="`tableData.${scope.$index}.planAmount`"
            :rules="rules.payAmount"
          >
            <el-input
              placeholder="请输入金额"
              v-model="scope.row.planAmount"
              @input="(val) => priceChange(val, scope.$index)"
            >
              <template slot="append">元</template>
            </el-input>
          </el-form-item>
        </template>
      </el-table-column>
      <el-table-column width="380" prop="payItem" align="left" label="款项周期">
        <template slot-scope="scope">
          <el-form-item :prop="`tableData.${scope.$index}.accruedCycle`">
            <el-date-picker
              v-model="scope.row.accruedCycle"
              type="daterange"
              :clearable="false"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions"
              value-format="yyyy-MM-dd"
              style="width: 350px"
            >
            </el-date-picker>
          </el-form-item>
        </template>
      </el-table-column>
      <el-table-column width="250" align="left" :label="`应${receiveOrPayFlag?'付':'收'}日期`">
        <template slot-scope="scope">
          <el-form-item :prop="`tableData.${scope.$index}.dueDate`">
            <el-date-picker
              :clearable="false"
              v-model="scope.row.dueDate"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </el-form-item>
        </template>
      </el-table-column>
      <el-table-column align="left" label="备注" width="200">
        <template slot-scope="scope">
          <el-form-item
            :prop="`tableData.${scope.$index}.remarks`"
            :rules="rules.remarks"
          >
            <el-input
              maxlength="500"
              show-word-limit
              placeholder="请输入备注"
              v-model="scope.row.remarks"
            >
            </el-input>
          </el-form-item>
        </template>
      </el-table-column>
      <el-table-column align="center" fixed="right" label="操作">
        <template slot-scope="scope">
          <el-popover
            :ref="scope.$index"
            v-if="isShowDeleteBtn"
            placement="bottom"
            width="230"
            popper-class="delete-order"
          >
            <p>确定删除该账期吗?</p>
            <div class="delete-order-btns" style="text-align: right; margin: 0">
              <el-button size="mini" class="cancel-btn" @click="cancel"
                >取消</el-button
              >
              <el-button
                type="primary"
                size="mini"
                @click="
                  cancel()
                  handleDel(scope.row.num)
                "
                >确定</el-button
              >
            </div>
            <el-button type="text" slot="reference">删除</el-button>
          </el-popover>
        </template>
      </el-table-column>
    </el-table>
  </el-form>
</template>
<script>
import config from '../config'
import { limitMoreZero } from '@/utils/validate'
import { mapState } from 'vuex'

export default {
  name: 'PreviewRentOrderMain',
  inject: ['receiveOrPayFlag'],
  data() {
    const {
      pickerOptions,
    } = config.call(this)
    return {
      pickerOptions,
      rules: {
        payAmount: [
          { required: true, message: '金额不能为空', trigger: 'blur' },
        ],
      },
    }
  },
  computed: {
    isShowDeleteBtn() {
      return this.tableDataFrom.tableData.length > 1
    },
    ...mapState({
      rentOrderFeeList: (state) => state.global.rentOrderFeeList,
    }),
  },
  props: {
    tableDataFrom: {
      type: Object,
      default() {
        return {}
      },
    },
    fundType: {
      type: [String, Number],
      default: '',
    },
  },
  methods: {
    // 校验
    // eslint-disable-next-line vue/no-unused-properties
    handleValidate() {
      return new Promise((resolve) => {
        this.$refs.otherPayFrom.validate((valid) => {
          if (!valid) {
            return false
          }
          resolve()
        })
      })
    },
    // popper弹框取消
    cancel() {
      document.body.click()
    },
    // 监听金额变化
    priceChange(value, index) {
      limitMoreZero(value, (v) => {
        this.$set(this.tableDataFrom.tableData[index], 'planAmount', v)
      }, 9)
    },

    // 获取收款类型名称
    getFreeTypeName(type) {
      return this.rentOrderFeeList.find((item) => item.code === type).name
    },
    // 获取数据中type类型所在位置
    getIndex(key) {
      const _index = this.tableDataFrom.tableData.findIndex(
        (item) => item.num === key,
      )
      return _index
    },
    // 删除条目
    handleDel(type) {
      this.$emit('handleDel', this.getIndex(type))
    },
  },
}
</script>
<style lang="scss" scoped>
.add-table ::v-deep .el-form-item {
  margin-top: 20px;
  margin-bottom: 20px;
}
.add-table ::v-deep td {
  padding: 0 !important;
}
.add-table {
  ::v-deep thead tr {
    background-color: #f7f8fa;
  }
}
#app .add-table ::v-deep thead tr th {
  border: none !important;
}
.delete-order {
  &-btns {
    text-align: right;
    margin: 0;
    display: flex;
    justify-content: flex-end;
    margin-top: 20px !important;
    .cancel-btn {
      height: 28px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 2px;
      border: 1px solid #dcdee0;
      font-family: PingFangSC-Regular;
      color: #323233;
      border-radius: 3px;
      font-size: 12px;
    }
  }
}
</style>
